import { useMutation, useQueryClient } from '@tanstack/react-query';
import { unwrap } from '@billda/api';
import { api } from '../../../shared/api/billdaApi';
import { platformKeys } from './usePlatformOrganisations';

/**
 * Errors are handled by the global QueryClient onError (shows snackbar).
 * Callers can override with mutate(orgId, { onSuccess }).
 */
export function useResendOwnerInvitation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (orgId: string) =>
      unwrap(
        await api.legacy.POST(
          '/api/v1/platform/organisations/{orgId}/owner-invitation/resend',
          {
            params: { path: { orgId } },
          }
        )
      ),

    onSuccess: (_data, orgId) => {
      queryClient.invalidateQueries({
        queryKey: [...platformKeys.all, 'organisations'],
      });
      queryClient.invalidateQueries({
        queryKey: platformKeys.organisation(orgId),
      });
    },
  });
}
